// import { Modal } from "@mui/material";
import { Box, Modal, Slider, Typography } from '@mui/material';
import { ArrowBackIcon, Button, ButtonMenu, ButtonMenuItem, CalculateIcon, CardFooter, Checkbox, CloseIcon, Flex, HelpIcon, IconButton, Image, Input, Link, SwapVertIcon, Text } from '@pancakeswap/uikit';
import { type } from '@testing-library/user-event/dist/type';
import Balance from 'components/Balance';
import React, { FC, useState, useEffect } from 'react';
import styled from 'styled-components';
import AnimatedArrow from './AnimatedArrow';
import RoiCalculatorFooter from './RoiCalculatorFooter';
import RoiCard from './RoiCard/RoiCard';
import { getLockUpAddress, getTokenAddress } from "utils/addressHelpers";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import UniRouterABI from "ABI/UniRouterABI.json";
import ERC20ABI from "ABI/ERC20ABI.json";
import { getContract } from "utils/contractHelpers";
import { ethers, BigNumber } from "ethers";
import { useWeb3React } from '@web3-react/core';
import addresses from "constants/contract";




interface StakeModalProps {
    onClose: () => void;
    open: boolean;
    // onBack?: () => void
    pool?: any;
    stackvalue?: any;
    usdvalue?: any;

}

const ModalHeader = styled(Box)`
    align-items: center;
    background: #00202F;
    display: flex;
    padding: 24px 24px;
    /* border-radius-top-left: 32px; */
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

`

const ModalHeaderText = styled(Box)`
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    justify-content: space-between;
`

const ScrollableContainer = styled(Box)`
  padding: 24px;
//   max-height: 50vh;
  overflow-y: auto;
  overflow:'scroll'
  ${({ theme }) => theme.mediaQueries.sm} {
    max-height: none;
  }
`

const StyledBalanceInput = styled(Box)`
    background-color: #1A3342;
    border: 1px solid #00FED9;
    border-radius: 16px;
    box-shadow: ${({ theme }) => theme.shadows["inset"]};
    padding: 8px 16px;
`;

const StyledInput = styled(Input) <{ textAlign?: string }>`
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  padding-left: 0;
  padding-right: 0;
  color: white;
  text-align: ${({ textAlign = "right" }) => textAlign};
  border: none;

  ::placeholder {
    color: #B1B3CB;
  }

  &:focus:not(:disabled) {
    box-shadow: none;
  }
`;

const SwitchUnitsButton = styled(IconButton)`
  width: 16px;
`;

const PCheckbox = styled(Checkbox)`
    box-shadow: 0px 0px 0px 1px #00FED9 ;
    background-color : #1A3342;
    &:checked{
        background-color : #00FED9;
    }
    &:hover, &:focus{
        box-shadow: 0px 0px 0px 1px #00FED9 !important;
    }
`

const ButtonComponent = styled(Button)`
    align-items: center;
    border: 0px none;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 20px;
    font-size: 12px;
    background-color: #00FED9;
    box-shadow: none;
    color: rgb(15, 33, 49);
`

const FullWidthButtonMenu = styled(ButtonMenu) <{ disabled?: boolean }>`
  width: 100%;
  height: 30px;
  background-color : #1A3342;
  box-shadow: 0px 0px 0px 1px #00FED9 ;
  border : none !important;

  & > button {
    width: 100%;
  }

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`

const PButtonMenuItem = styled(ButtonMenuItem)`
    color: #000000;
    padding : 0;
`

const RoiCalculatorModal: React.FunctionComponent<StakeModalProps> = ({
    open,
    onClose,
    pool,
    stackvalue,
    usdvalue
}) => {

    // const DURATION = useMemo(() => [t('1D'), t('7D'), t('30D'), t('1Y'), t('5Y')], [t])
    const { active } = useWeb3React();
    const [index, setIndex] = useState(0);
    const handleClick = (newIndex) => setIndex(newIndex);
    const [cpmCheck, setcpmCheck] = useState(true);
    const [compounding, setCompounding] = useState(0);
    const handlecompoundingClick = (newIndex) => setCompounding(newIndex);

    const [tokenRoivalue, setTokenRoivalue] = useState(0);
    const [usdRoivalue, setUsdRoivalue] = useState("0");

    const [inputToggle, setInputToggle] = useState(true);
    const [roiUSDInput, setRoiUsdInput] = useState(0);
    const [roitokenInput, setRoiTokenInput] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false)

    const [inputflag, setInputFlag] = useState(false);

    useEffect(() => {
        if (stackvalue) {
            setRoiUsdInput(usdvalue)
            setRoiTokenInput(parseFloat(stackvalue))
        }
    }, [open]);

    // const lockupAddress = getLockUpAddress();
    // const tokenAddress = getTokenAddress();

    const USDCalculation = async (tokenInput, roiFlag) => {
        // const lockUpContract = getContract(DrivenLockupABI, lockupAddress);
        // let routeAddress = await lockUpContract.uniRouterAddress();
        // const routerContract = getContract(UniRouterABI, routeAddress);
        if (tokenInput >= 0 && tokenInput) {
            roiFlag && setRoiUsdInput((tokenInput * pool.tokenUsdprice))
            return (tokenInput * pool.tokenUsdprice)
            // const routerOut = await routerContract.getAmountsOut(ethers.utils.parseEther(tokenInput.toString()), addresses.TokenToUsd);
            // const usdContract = getContract(ERC20ABI, addresses.TokenToUsd[3]);
            // const usdDecimal = await usdContract.decimals();
            // roiFlag && setRoiUsdInput(parseFloat(ethers.utils.formatUnits((routerOut[3]).toString(), usdDecimal)))
            // return parseFloat(ethers.utils.formatUnits((routerOut[3]).toString(), usdDecimal))

        } else {
            roiFlag && setRoiUsdInput(0);
            return 0;
        }
    }
    useEffect(() => {
        if (!inputToggle) {
            USDCalculation(roitokenInput, true);
        }
    }, [roitokenInput]);

    const TokenCalculation = async (usdInput, flag) => {
        // const lockUpContract = getContract(DrivenLockupABI, lockupAddress);
        // let routeAddress = await lockUpContract.uniRouterAddress();
        // const routerContract = getContract(UniRouterABI, routeAddress);
        if (usdInput >= 0 && usdInput) {
            flag && setRoiTokenInput((usdInput / pool.tokenUsdprice));
            return (usdInput / pool.tokenUsdprice);
            // const routerOut = await routerContract.getAmountsOut(ethers.utils.parseEther(usdInput.toString()), addresses.UsdToToken);
            // const tokenContract = getContract(ERC20ABI, addresses.UsdToToken[3]);
            // const tokenDecimal = await tokenContract.decimals();
            // flag && setRoiTokenInput(parseFloat(ethers.utils.formatUnits((routerOut[3]).toString(), tokenDecimal)))
            // return (parseFloat(ethers.utils.formatUnits((routerOut[3]).toString(), tokenDecimal)));
        } else {
            flag && setRoiTokenInput(0);
            return 0;
        }
    }
    useEffect(() => {
        if (inputToggle) {
            TokenCalculation(roiUSDInput, true);
        }
    }, [roiUSDInput]);

    const setUsdValue = (e) => {
        setRoiUsdInput(e.target.value);
    }
    const setTokenValue = (e) => {
        setRoiTokenInput(e.target.value);
    }

    const simpleROICalculation = (ti, a, d) => {
        return (((parseFloat(ti.toString())) * (parseFloat(a.toString()))) * (d))
    }
    const simplePrincipalCalculation = (ti, a, d) => {
        // console.log(((parseFloat(ti.toString())) / (parseFloat(a.toString()))) * (d));
        return ((parseFloat(ti.toString())) / ((parseFloat(a.toString())) * (d)))
    }
    const compoundPrincipalCalculation = (tokeninput, apy, duration, cmpday) => {
        let cmp = (duration / cmpday);
        let oneapy = (apy) * (cmpday);
        let powerCal = oneapy + 1;
        powerCal = Math.pow(parseFloat(powerCal.toString()), -cmp);
        return (powerCal * tokeninput);
    }
    const compoundROICalculation = (tokeninput, apy, duration, cmpday) => {
        let cmp = (duration / cmpday);
        let oneapy = (apy) * (cmpday);
        let powerCal = oneapy + 1;
        powerCal = Math.pow(parseFloat(powerCal.toString()), (cmp));
        return (tokeninput * powerCal) - tokeninput;
    }

    const PrincipalCalculation = async (tokeninput) => {
        let PA;
        let duration;
        let cmp;
        // let apy = (pool.apy).div(36500);
        let apy = (pool.apy) / (36500);
        switch (index) {
            case 0:
                duration = 1;
                break;
            case 1:
                duration = 7;
                break;
            case 2:
                duration = 30;
                break;
            case 3:
                duration = 365;
                break;
            case 4:
                duration = 1825;
                break;
        }
        switch (compounding) {
            case 0:
                cmp = 1;
                break;
            case 1:
                cmp = 7;
                break;
            case 2:
                cmp = 14;
                break;
            case 3:
                cmp = 30;
                break;

        }
        if (tokeninput) {
            if (cpmCheck) {
                console.log(`${tokeninput},${apy}, ${duration}`);
                PA = simplePrincipalCalculation(tokeninput, apy, duration);
                setRoiTokenInput(PA);
                let usdcalc = await USDCalculation((PA), false);
                setRoiUsdInput(usdcalc);
            }
            else {
                PA = (duration / cmp) <= 1 ? simplePrincipalCalculation(tokeninput, apy, duration) : compoundPrincipalCalculation(tokeninput, apy, duration, cmp);
                setRoiTokenInput(PA);
                let usdcalc = await USDCalculation((PA), false);
                setRoiUsdInput(usdcalc);
            }
        } else {
            setRoiTokenInput(0)
            setRoiUsdInput(0)
        }
    }
    const ROICalculation = async (tokeninput) => {
        let ROI;
        let duration;
        let cmp;
        // let apy = (pool.apy).div(36500);
        let apy = (pool.apy) / (36500);
        switch (index) {
            case 0:
                duration = 1;
                break;
            case 1:
                duration = 7;
                break;
            case 2:
                duration = 30;
                break;
            case 3:
                duration = 365;
                break;
            case 4:
                duration = 1825;
                break;
        }
        switch (compounding) {
            case 0:
                cmp = 1;
                break;
            case 1:
                cmp = 7;
                break;
            case 2:
                cmp = 14;
                break;
            case 3:
                cmp = 30;
                break;

        }
        if (tokeninput) {
            if (cpmCheck) {
                // ROI = ((parseFloat(tokeninput.toString())) * (parseFloat(apy.toString()))) * (duration)
                ROI = simpleROICalculation(tokeninput, apy, duration);
                setTokenRoivalue(ROI)
                let usdcalc = await USDCalculation((ROI), false);
                setUsdRoivalue(usdcalc.toString());
            }
            else {
                ROI = (duration / cmp) <= 1 ? simpleROICalculation(tokeninput, apy, duration) : compoundROICalculation(tokeninput, apy, duration, cmp);
                setTokenRoivalue(ROI);
                let usdcalc = await USDCalculation((ROI), false);
                setUsdRoivalue(usdcalc.toString());
            }
        } else {
            setTokenRoivalue(0)
            setUsdRoivalue("0")
        }
    }

    useEffect(() => {
        if (!inputflag) {
            ROICalculation(roitokenInput);
        }
    }, [roitokenInput, roiUSDInput, index, cpmCheck, compounding]);

    return (
        <>

            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        p: 4,
                        overflow: 'auto',
                    }}>
                    <Box sx={{
                        width: 'auto',
                        background: '#1A3342',
                        borderRadius: '32px',
                        zIndex: '100',
                        minWidth: '330px',
                        maxWidth: '350px',
                        maxHeight: '100vh',
                        overflow: 'hidden',
                    }}>
                        <ModalHeader id="modal-modal-title">
                            <ModalHeaderText>

                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        lineHeight: '1.1',
                                        display: 'flex',
                                        gap: '10px',
                                        color: '#00FED9',
                                    }}>
                                    {/* <Box sx={{ display: 'flex', alignItems: 'center', }}>
                                        <ArrowBackIcon color="white" width="20px" height="20px" style={{ cursor: 'pointer' }} onClick={onClose} />
                                    </Box> */}
                                    ROI Calculator
                                </Box>
                                <CloseIcon color="#00FED9" width="20px" height="20px" onClick={onClose} style={{ cursor: 'pointer' }} />
                            </ModalHeaderText>

                        </ModalHeader>
                        <ScrollableContainer sx={{ ...(isExpanded && { maxHeight: '55vh' }) }}>
                            <Flex alignItems="center" justifyContent="space-between" mb="8px">
                                <Text color='white' fontWeight={600} lineHeight={1.5} fontSize={'12px'} textTransform={'uppercase'} >DVX Staked</Text>
                            </Flex>
                            <StyledBalanceInput>
                                <Flex justifyContent="flex-end">
                                    {inputToggle ?
                                        <Box>
                                            <Flex alignItems="center">
                                                <StyledInput
                                                    pattern={`^[0-9]*[.,]?[0-9]{0,${'18'}}$`}
                                                    inputMode="decimal"
                                                    min="0"
                                                    placeholder={'0.0'}
                                                    onChange={setUsdValue}
                                                    value={roiUSDInput}
                                                />
                                                <Text color='white' marginLeft={'5px'} marginBottom={'2px'} >USD</Text>
                                            </Flex>

                                            <Flex alignItems="center" justifyContent={'end'}>
                                                <Balance
                                                    fontSize="12px"
                                                    color="#B1B3CB"
                                                    textAlign="right"
                                                    decimals={2}
                                                    value={roitokenInput}
                                                    unit=""
                                                    prefix="~"
                                                />
                                                <Text color="#B1B3CB" marginLeft={'5px'} fontSize={'12px'} >{pool.symbol}</Text>
                                            </Flex>
                                        </Box>
                                        :
                                        <Box>
                                            <Flex alignItems="center">
                                                <StyledInput
                                                    pattern={`^[0-9]*[.,]?[0-9]{0,${'18'}}$`}
                                                    inputMode="decimal"
                                                    min="0"
                                                    placeholder={'0.0'}
                                                    onChange={setTokenValue}
                                                    value={roitokenInput}
                                                />
                                                <Text color='white' marginLeft={'5px'} marginBottom={'2px'} >{pool.symbol}</Text>
                                            </Flex>

                                            <Flex alignItems="center" justifyContent={'end'}>
                                                <Balance
                                                    fontSize="12px"
                                                    color="#B1B3CB"
                                                    textAlign="right"
                                                    decimals={2}
                                                    value={roiUSDInput}
                                                    unit=""
                                                    prefix="~"
                                                />
                                                <Text color="#B1B3CB" marginLeft={'5px'} fontSize={'12px'} >USD</Text>
                                            </Flex>
                                        </Box>}
                                    <Flex alignItems="center" pl="12px">
                                        <SwitchUnitsButton scale="sm" variant="text" >
                                            <SwapVertIcon color="white" onClick={() => setInputToggle(!inputToggle)} />
                                        </SwitchUnitsButton>
                                    </Flex>
                                </Flex>
                            </StyledBalanceInput>
                            <Flex justifyContent="space-between" mt="8px">
                                <ButtonComponent
                                    scale="xs"
                                    mr="4px"
                                    p="4px 16px"
                                    width="68px"
                                    color='rgb(239, 244, 245)'
                                    onClick={() => setRoiUsdInput(100)}
                                >
                                    $100
                                </ButtonComponent>
                                <ButtonComponent
                                    scale="xs"
                                    mr="4px"
                                    p="4px 16px"
                                    width="68px"
                                    onClick={() => setRoiUsdInput(1000)}
                                >
                                    $1000
                                </ButtonComponent>
                                <ButtonComponent
                                    scale="xs"
                                    mr="4px"
                                    p="4px 16px"
                                    width="128px"
                                    disabled={!active}
                                    onClick={() => setRoiTokenInput(parseFloat(ethers.utils.formatEther(pool.user.tokenbalance)))}
                                >
                                    My Balance
                                </ButtonComponent>
                                <span >
                                    <HelpIcon width="16px" height="16px" color="white" />
                                </span>
                                {/* {tooltipVisible && tooltip} */}
                            </Flex>

                            <Text mt="24px" color="white" bold fontSize="12px" textTransform="uppercase">
                                Staked for
                            </Text>
                            <FullWidthButtonMenu variant="primary" activeIndex={index} onItemClick={handleClick}>
                                <PButtonMenuItem height={'30px'} ><Box sx={{ ...(index !== 0 && { color: 'white' }) }}>1D</Box></PButtonMenuItem>
                                <PButtonMenuItem height={'30px'}><Box sx={{ ...(index !== 1 && { color: 'white' }) }}>7D</Box></PButtonMenuItem>
                                <PButtonMenuItem height={'30px'}><Box sx={{ ...(index !== 2 && { color: 'white' }) }}>30D</Box></PButtonMenuItem>
                                <PButtonMenuItem height={'30px'}><Box sx={{ ...(index !== 3 && { color: 'white' }) }}>1Y</Box></PButtonMenuItem>
                                <PButtonMenuItem height={'30px'}><Box sx={{ ...(index !== 4 && { color: 'white' }) }}>5Y</Box></PButtonMenuItem>
                            </FullWidthButtonMenu>

                            {pool.enableCompound === 'true' && <> <Text mt="24px" color="white" bold fontSize="12px" textTransform="uppercase">
                                Compounding every
                            </Text>
                                <Flex alignItems="center">
                                    <Flex flex="1">
                                        <PCheckbox scale="sm" onClick={() => setcpmCheck(!cpmCheck)} />
                                    </Flex>
                                    <Flex flex="6">
                                        <FullWidthButtonMenu activeIndex={compounding} onItemClick={handlecompoundingClick} disabled={cpmCheck}>
                                            <PButtonMenuItem height={'30px'} ><Box sx={{ ...(compounding !== 0 && { color: 'white' }) }}>1D</Box></PButtonMenuItem>
                                            <PButtonMenuItem height={'30px'} ><Box sx={{ ...(compounding !== 1 && { color: 'white' }) }}>7D</Box></PButtonMenuItem>
                                            <PButtonMenuItem height={'30px'} ><Box sx={{ ...(compounding !== 2 && { color: 'white' }) }}>14D</Box></PButtonMenuItem>
                                            <PButtonMenuItem height={'30px'} ><Box sx={{ ...(compounding !== 3 && { color: 'white' }) }}>30D</Box></PButtonMenuItem>
                                        </FullWidthButtonMenu>
                                    </Flex>
                                </Flex>
                            </>
                            }
                            <AnimatedArrow calculatorState={'state'} />

                            <Flex>
                                <RoiCard pool={pool} PrincipalCalculation={PrincipalCalculation} USDCalculation={USDCalculation} tokenRoivalue={tokenRoivalue} setTokenRoivalue={setTokenRoivalue} usdRoivalue={usdRoivalue} setUsdRoivalue={setUsdRoivalue} inputflag={inputflag} setInputFlag={setInputFlag} />
                            </Flex>
                        </ScrollableContainer>
                        <RoiCalculatorFooter pool={pool} isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
                    </Box>
                </Box>
            </Modal>

        </>
    );
};

export default RoiCalculatorModal;
